/**
 * AppCard.jsx
 * Renders a single application tile in the portal grid.
 * Clicking opens the app URL in the same tab (Entra token carries via sessionStorage).
 */

import React from "react";

const STATUS_LABELS = {
  live:          null,                    // No badge for live
  beta:          { label: "BETA",         color: "#f59e0b" },
  "coming-soon": { label: "COMING SOON",  color: "#6b7280" },
};

export default function AppCard({ app }) {
  const badge  = STATUS_LABELS[app.status];
  const accent = `hsl(${app.accentColor})`;

  function handleClick() {
    if (app.status === "coming-soon") return;
    window.location.href = app.url;
  }

  return (
    <div
      className={`app-card ${app.status === "coming-soon" ? "app-card--disabled" : ""}`}
      onClick={handleClick}
      role="button"
      tabIndex={app.status === "coming-soon" ? -1 : 0}
      aria-label={`Open ${app.name}`}
      onKeyDown={e => e.key === "Enter" && handleClick()}
      style={{ "--accent": accent }}
    >
      {/* Accent bar at top */}
      <div className="app-card__accent-bar" />

      <div className="app-card__body">
        <div className="app-card__icon-row">
          <span className="app-card__icon" aria-hidden="true">{app.icon}</span>
          {badge && (
            <span
              className="app-card__badge"
              style={{ color: badge.color, borderColor: badge.color }}
            >
              {badge.label}
            </span>
          )}
        </div>

        <h2 className="app-card__name">{app.name}</h2>
        <p className="app-card__tagline">{app.tagline}</p>
      </div>

      <div className="app-card__footer">
        <span className="app-card__arrow" aria-hidden="true">→</span>
      </div>
    </div>
  );
}
